import React, { useState } from 'react';
import PropTypes from 'prop-types';

import round from 'lodash/round';

import { connect } from 'react-redux';

import AddInternalBrokerModal from 'bundles/apex/deals/show/brokers/internal/modal';
import AddOutsideBrokerModal from 'bundles/apex/deals/show/brokers/outside/add_modal';
import { Button } from 'components/ui/button';
import Card from 'bundles/apex/card';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import Deductions from './deductions';
import InternalCommissions from './internal_commissions';
import OutsideCommissions from './outside_commissions';
import Row from './row';
import { getTransactionSideLabel } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';
import { USD } from 'helpers/formatters/number_formats';

export function TransactionSideCard({ deal, transactionSide, transactionSideOptions }) {
  const [showAddInternalBrokerModal, setShowAddInternalBrokerModal] = useState(false);
  const [showAddOutsideBrokerModal, setShowAddOutsideBrokerModal] = useState(false);

  const details = deal.transactionSideDetails.find(details => details.transactionSide === transactionSide);
  const label = getTransactionSideLabel(transactionSide, transactionSideOptions);

  return <React.Fragment>
    <Card
      controls={[
        <Button
          className="me-2"
          icon={faCirclePlus}
          key="internal"
          label="Add Internal Broker"
          size="sm"
          variant="ghost"
          onClick={() => setShowAddInternalBrokerModal(true)}
        />,
        <Button
          icon={faCirclePlus}
          key="outside"
          label="Add Outside Broker"
          size="sm"
          variant="ghost"
          onClick={() => setShowAddOutsideBrokerModal(true)}
        />,
      ]}
      label={label}
      verticalBody
    >
      <Row label={`${label} Gross Percent`} value={`${round(details.grossPercent, 2)}%`} />
      <Row borderBottom label={`${label} Gross Amount`} value={USD.format(details.grossAmount)} />
      <OutsideCommissions transactionSide={transactionSide} />
      <Deductions transactionSide={transactionSide} />
      <InternalCommissions transactionSide={transactionSide} />
    </Card>

    <AddInternalBrokerModal
      show={showAddInternalBrokerModal}
      transactionSide={transactionSide}
      onHide={() => setShowAddInternalBrokerModal(false)}
    />

    <AddOutsideBrokerModal
      show={showAddOutsideBrokerModal}
      transactionSide={transactionSide}
      onClose={() => setShowAddOutsideBrokerModal(false)}
    />
  </React.Fragment>;
}

TransactionSideCard.propTypes = {
  deal: PropTypes.shape({
    transactionSideDetails: PropTypes.arrayOf(PropTypes.shape({
      grossAmount: PropTypes.number.isRequired,
      grossPercent: PropTypes.number.isRequired,
      transactionSide: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  transactionSide: PropTypes.string.isRequired,
  transactionSideOptions: PropTypes.array,
};

const mapStateToProps = state => ({
  deal: state.deal,
  transactionSideOptions: state.options.transactionSide,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionSideCard);
